import { createStateSelectorHook } from 'src/lib/sweetState';
import { CustomerPersonaStore } from 'src/store';

const useCustomerPersonaState = createStateSelectorHook(CustomerPersonaStore, ['customerPersonas']);

export const useCustomerPersonas = () => {
  const { customerPersonas } = useCustomerPersonaState();
  return customerPersonas;
};
